<script lang="ts" setup>
import { computed } from 'vue'
import { v4 as uuid } from 'uuid'
import type { HomePageConfig } from '../../configs/types'
import ModuleCard from './ModuleCard.vue'
import { resources } from '@/config/brands'

const props = defineProps<{
  module: any
  config: HomePageConfig
  currentTagId: string
  cardClass?: string
  headerClass?: string
  gotoBook: (id: string) => void
  gotoTags: (id: string) => void
  getCurrentTagResources: (col: any) => any[]
  getCurrentShowTags: (col: any) => any[]
  handleTagClick: (tagId: string) => void
}>()

// 定义样式变量供 CSS v-bind 使用
const tagActiveBg = computed(() => props.config.theme.tagActiveBg)
const tagActiveText = computed(() => props.config.theme.tagActiveText)
const tagInactiveBg = computed(() => props.config.theme.tagInactiveBg)
const tagInactiveText = computed(() => props.config.theme.tagInactiveText)
function handleSeeAll() {
  props.gotoTags(props.currentTagId)
}
</script>

<template>
  <ModuleCard
    :title-text="module.showName"
    :action-text-value="config.texts.seeAll"
    :card-class="cardClass"
    :header-class="headerClass"
    @action="handleSeeAll"
  >
    <div class="flex flex-wrap  mt-8px">
      <div
        v-for="tag in getCurrentShowTags(module)" :key="tag.id"
        class="tag-button flex items-center justify-center rounded-full mt-2 text-12px whitespace-nowrap py-1 px-3 mr-2"
        :class="{ 'tag-active': currentTagId === tag.id }"
        @click="handleTagClick(tag.id)"
      >
        <img
          v-if="tag.isHot"
          :src="currentTagId === tag.id ? resources.tagsIcons.hotIcon : resources.tagsIcons.hotIconRed"
          class="thumbnail_2 mr-1" style="width: 12px; height: 12px;" alt="火花图标"
        >
        {{ tag.tagName }}
      </div>
    </div>
    <div class="mt-4 grid grid-cols-3 gap-9px">
      <div v-for="item in getCurrentTagResources(module)" :key="item.id">
        <div @click="gotoBook(item.id)">
          <BizBookCover
            :id="uuid()"
            :src="item.contentCoverUrl || ''"
            :extra="{
              module_name: module.showName,
              module_id: module.id,
              module_type: module.columnType,
              ...item,
            }"
            class="rounded-8px"
          />
          <p class="mt-5px text-12px line-clamp-2 font-medium text-n-text-1">
            {{ item.contentName }}
          </p>
        </div>
      </div>
    </div>
  </ModuleCard>
</template>

<style lang="scss" scoped>
.tag-button {
  background-color: v-bind(tagInactiveBg);
  color: v-bind(tagInactiveText);
}

.tag-button.tag-active {
  background-color: v-bind(tagActiveBg);
  color: v-bind(tagActiveText);
}
</style>
